import { getApps, initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, GoogleAuthProvider, OAuthProvider, sendEmailVerification as firebaseSendEmailVerification, sendPasswordResetEmail as firebaseSendPasswordResetEmail } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';

import { firebaseConfig, emulatorHosts, environmentName } from '../environment';

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
if (emulatorHosts) {
  connectAuthEmulator(auth, emulatorHosts.auth, { disableWarnings: true });
  const endpoint = new URL(`http://${emulatorHosts.firestore}`);
  connectFirestoreEmulator(db, endpoint.hostname, Number(endpoint.port));
}
const googleProvider = new GoogleAuthProvider();
const applicantGoogleProvider = new GoogleAuthProvider();
const applicantMicrosoftProvider = new OAuthProvider('microsoft.com');

googleProvider.setCustomParameters({
  hd: 'chemcab.com',
  prompt: 'select_account',
});

applicantGoogleProvider.setCustomParameters({
  prompt: 'select_account',
});

applicantMicrosoftProvider.setCustomParameters({
  prompt: 'select_account',
});

export {
  app,
  applicantGoogleProvider,
  applicantMicrosoftProvider,
  auth,
  db,
  googleProvider,
};

function requireEmailEnvironment() {
  if (environmentName === 'dev') {
    throw new Error('Email is simulated in dev. Use the seeded verified test account; Firebase verification and reset emails are disabled.');
  }
}
export async function sendEmailVerification(...args) {
  requireEmailEnvironment();
  return firebaseSendEmailVerification(...args);
}
export async function sendPasswordResetEmail(...args) {
  requireEmailEnvironment();
  return firebaseSendPasswordResetEmail(...args);
}
